import React, { useCallback, useReducer } from 'react';
import { CreateVideoStudioActionTypes } from '../createVideoStudioModalActions';
import { createVideoStudioReducer } from './createVideoStudioModalReducer';
import {
	createVideoStudioInitialState,
	CreateVideoStudioContext,
	TTypeOfCreateVideoStudioModalWindow,
} from './createVideoStudioModalContext';
import { ICreateVideoStudio } from 'types';

const CreateVideoStudioState = ({ children }: JSX.ElementChildrenAttribute) => {
	const [state, dispatch] = useReducer(createVideoStudioReducer, createVideoStudioInitialState);

	const changeName = useCallback((value: string) => {
		dispatch({
			type: CreateVideoStudioActionTypes.CHANGE_NAME,
			payload: {
				name: value,
			},
		});
	}, []);

	const setDataForSubmit = useCallback((value: ICreateVideoStudio | null) => {
		dispatch({
			type: CreateVideoStudioActionTypes.SET_DATA_FOR_SUBMIT,
			payload: {
				dataForSubmit: value,
			},
		});
	}, []);

	const changeTypeOfModalWindow = useCallback((value: TTypeOfCreateVideoStudioModalWindow) => {
		dispatch({
			type: CreateVideoStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	}, []);

	const resetFields = useCallback(() => dispatch({ type: CreateVideoStudioActionTypes.RESET_FIELDS }), []);

	return (
		<CreateVideoStudioContext.Provider
			value={{
				changeName,
				setDataForSubmit,
				changeTypeOfModalWindow,
				resetFields,
				name: state.name,
				dataForSubmit: state.dataForSubmit,
				typeOfModalWindow: state.typeOfModalWindow,
			}}>
			{children}
		</CreateVideoStudioContext.Provider>
	);
};

export default React.memo(CreateVideoStudioState);
